import React from 'react';
import { useNavigate } from 'react-router-dom';
import './InvestmentCancel.css';

const InvestmentCancel = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate('/investment', { state: { scrollToInvestmentCTA2: true } });
  };

  const handleGoAuthentication= () => {
    navigate('/');
  };

  return (
    <div className="investment-cancel-page">
      <div className="investment-cancel-container">
        <div className="cancel-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        </div>
        
        <h1 className="cancel-title">Payment Cancelled</h1>
        <p className="cancel-subtitle">
          Your payment was cancelled. No charges were made to your account.
        </p>

        <div className="cancel-message">
          <p>
            If you encountered any issues or have questions about our plans, 
            please don't hesitate to contact our support team. We're here to help!
          </p>
        </div>

        <div className="cancel-actions">
          <button 
            className="btn-secondary"
            onClick={handleGoAuthentication}
          >
            Back to Authentication
          </button>
          <button 
            className="btn-primary"
            onClick={handleTryAgain}
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvestmentCancel;
